/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectItemsTasksCreateProjectItemTaskPost } from '../fn/project-tasks/api-project-items-tasks-create-project-item-task-post';
import { ApiProjectItemsTasksCreateProjectItemTaskPost$Params } from '../fn/project-tasks/api-project-items-tasks-create-project-item-task-post';
import { apiProjectItemsTasksCreateProjectItemTaskPost$Plain } from '../fn/project-tasks/api-project-items-tasks-create-project-item-task-post-plain';
import { ApiProjectItemsTasksCreateProjectItemTaskPost$Plain$Params } from '../fn/project-tasks/api-project-items-tasks-create-project-item-task-post-plain';
import { apiProjectItemsTasksDeleteProjectItemTaskDelete } from '../fn/project-tasks/api-project-items-tasks-delete-project-item-task-delete';
import { ApiProjectItemsTasksDeleteProjectItemTaskDelete$Params } from '../fn/project-tasks/api-project-items-tasks-delete-project-item-task-delete';
import { apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain } from '../fn/project-tasks/api-project-items-tasks-delete-project-item-task-delete-plain';
import { ApiProjectItemsTasksDeleteProjectItemTaskDelete$Plain$Params } from '../fn/project-tasks/api-project-items-tasks-delete-project-item-task-delete-plain';
import { apiProjectItemsTasksGetProjectItemsTasksPost } from '../fn/project-tasks/api-project-items-tasks-get-project-items-tasks-post';
import { ApiProjectItemsTasksGetProjectItemsTasksPost$Params } from '../fn/project-tasks/api-project-items-tasks-get-project-items-tasks-post';
import { apiProjectItemsTasksGetProjectItemsTasksPost$Plain } from '../fn/project-tasks/api-project-items-tasks-get-project-items-tasks-post-plain';
import { ApiProjectItemsTasksGetProjectItemsTasksPost$Plain$Params } from '../fn/project-tasks/api-project-items-tasks-get-project-items-tasks-post-plain';
import { apiProjectItemsTasksUpdateProjectItemTaskPost } from '../fn/project-tasks/api-project-items-tasks-update-project-item-task-post';
import { ApiProjectItemsTasksUpdateProjectItemTaskPost$Params } from '../fn/project-tasks/api-project-items-tasks-update-project-item-task-post';
import { apiProjectItemsTasksUpdateProjectItemTaskPost$Plain } from '../fn/project-tasks/api-project-items-tasks-update-project-item-task-post-plain';
import { ApiProjectItemsTasksUpdateProjectItemTaskPost$Plain$Params } from '../fn/project-tasks/api-project-items-tasks-update-project-item-task-post-plain';
import { apiProjectTaskCreateProjectTaskPost } from '../fn/project-tasks/api-project-task-create-project-task-post';
import { ApiProjectTaskCreateProjectTaskPost$Params } from '../fn/project-tasks/api-project-task-create-project-task-post';
import { apiProjectTaskCreateProjectTaskPost$Plain } from '../fn/project-tasks/api-project-task-create-project-task-post-plain';
import { ApiProjectTaskCreateProjectTaskPost$Plain$Params } from '../fn/project-tasks/api-project-task-create-project-task-post-plain';
import { apiProjectTaskDeleteProjectTaskDelete } from '../fn/project-tasks/api-project-task-delete-project-task-delete';
import { ApiProjectTaskDeleteProjectTaskDelete$Params } from '../fn/project-tasks/api-project-task-delete-project-task-delete';
import { apiProjectTaskDeleteProjectTaskDelete$Plain } from '../fn/project-tasks/api-project-task-delete-project-task-delete-plain';
import { ApiProjectTaskDeleteProjectTaskDelete$Plain$Params } from '../fn/project-tasks/api-project-task-delete-project-task-delete-plain';
import { apiProjectTaskDependencyCreateProjectTaskDependencyPost } from '../fn/project-tasks/api-project-task-dependency-create-project-task-dependency-post';
import { ApiProjectTaskDependencyCreateProjectTaskDependencyPost$Params } from '../fn/project-tasks/api-project-task-dependency-create-project-task-dependency-post';
import { apiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain } from '../fn/project-tasks/api-project-task-dependency-create-project-task-dependency-post-plain';
import { ApiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain$Params } from '../fn/project-tasks/api-project-task-dependency-create-project-task-dependency-post-plain';
import { apiProjectTaskDependencyDeleteProjectTaskDependencyDelete } from '../fn/project-tasks/api-project-task-dependency-delete-project-task-dependency-delete';
import { ApiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Params } from '../fn/project-tasks/api-project-task-dependency-delete-project-task-dependency-delete';
import { apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain } from '../fn/project-tasks/api-project-task-dependency-delete-project-task-dependency-delete-plain';
import { ApiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain$Params } from '../fn/project-tasks/api-project-task-dependency-delete-project-task-dependency-delete-plain';
import { apiProjectTaskDependencyGetProjectTaskDependenciesPost } from '../fn/project-tasks/api-project-task-dependency-get-project-task-dependencies-post';
import { ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Params } from '../fn/project-tasks/api-project-task-dependency-get-project-task-dependencies-post';
import { apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain } from '../fn/project-tasks/api-project-task-dependency-get-project-task-dependencies-post-plain';
import { ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain$Params } from '../fn/project-tasks/api-project-task-dependency-get-project-task-dependencies-post-plain';
import { apiProjectTaskDependencyUpdateProjectTaskDependencyPost } from '../fn/project-tasks/api-project-task-dependency-update-project-task-dependency-post';
import { ApiProjectTaskDependencyUpdateProjectTaskDependencyPost$Params } from '../fn/project-tasks/api-project-task-dependency-update-project-task-dependency-post';
import { apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain } from '../fn/project-tasks/api-project-task-dependency-update-project-task-dependency-post-plain';
import { ApiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain$Params } from '../fn/project-tasks/api-project-task-dependency-update-project-task-dependency-post-plain';
import { apiProjectTaskGetProjectTaskPost } from '../fn/project-tasks/api-project-task-get-project-task-post';
import { ApiProjectTaskGetProjectTaskPost$Params } from '../fn/project-tasks/api-project-task-get-project-task-post';
import { apiProjectTaskGetProjectTaskPost$Plain } from '../fn/project-tasks/api-project-task-get-project-task-post-plain';
import { ApiProjectTaskGetProjectTaskPost$Plain$Params } from '../fn/project-tasks/api-project-task-get-project-task-post-plain';
import { apiProjectTaskGetProjectTasksNamesPost } from '../fn/project-tasks/api-project-task-get-project-tasks-names-post';
import { ApiProjectTaskGetProjectTasksNamesPost$Params } from '../fn/project-tasks/api-project-task-get-project-tasks-names-post';
import { apiProjectTaskGetProjectTasksNamesPost$Plain } from '../fn/project-tasks/api-project-task-get-project-tasks-names-post-plain';
import { ApiProjectTaskGetProjectTasksNamesPost$Plain$Params } from '../fn/project-tasks/api-project-task-get-project-tasks-names-post-plain';
import { apiProjectTaskGetProjectTasksPost } from '../fn/project-tasks/api-project-task-get-project-tasks-post';
import { ApiProjectTaskGetProjectTasksPost$Params } from '../fn/project-tasks/api-project-task-get-project-tasks-post';
import { apiProjectTaskGetProjectTasksPost$Plain } from '../fn/project-tasks/api-project-task-get-project-tasks-post-plain';
import { ApiProjectTaskGetProjectTasksPost$Plain$Params } from '../fn/project-tasks/api-project-task-get-project-tasks-post-plain';
import { apiProjectTaskUpdateProjectTaskPost } from '../fn/project-tasks/api-project-task-update-project-task-post';
import { ApiProjectTaskUpdateProjectTaskPost$Params } from '../fn/project-tasks/api-project-task-update-project-task-post';
import { apiProjectTaskUpdateProjectTaskPost$Plain } from '../fn/project-tasks/api-project-task-update-project-task-post-plain';
import { ApiProjectTaskUpdateProjectTaskPost$Plain$Params } from '../fn/project-tasks/api-project-task-update-project-task-post-plain';
import { apiTaskBudgetCostCreateTaskBudgetCostPost } from '../fn/project-tasks/api-task-budget-cost-create-task-budget-cost-post';
import { ApiTaskBudgetCostCreateTaskBudgetCostPost$Params } from '../fn/project-tasks/api-task-budget-cost-create-task-budget-cost-post';
import { apiTaskBudgetCostCreateTaskBudgetCostPost$Plain } from '../fn/project-tasks/api-task-budget-cost-create-task-budget-cost-post-plain';
import { ApiTaskBudgetCostCreateTaskBudgetCostPost$Plain$Params } from '../fn/project-tasks/api-task-budget-cost-create-task-budget-cost-post-plain';
import { apiTaskBudgetCostDeleteTaskBudgetCostDelete } from '../fn/project-tasks/api-task-budget-cost-delete-task-budget-cost-delete';
import { ApiTaskBudgetCostDeleteTaskBudgetCostDelete$Params } from '../fn/project-tasks/api-task-budget-cost-delete-task-budget-cost-delete';
import { apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain } from '../fn/project-tasks/api-task-budget-cost-delete-task-budget-cost-delete-plain';
import { ApiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain$Params } from '../fn/project-tasks/api-task-budget-cost-delete-task-budget-cost-delete-plain';
import { apiTaskBudgetCostGetTaskBudgetCostsPost } from '../fn/project-tasks/api-task-budget-cost-get-task-budget-costs-post';
import { ApiTaskBudgetCostGetTaskBudgetCostsPost$Params } from '../fn/project-tasks/api-task-budget-cost-get-task-budget-costs-post';
import { apiTaskBudgetCostGetTaskBudgetCostsPost$Plain } from '../fn/project-tasks/api-task-budget-cost-get-task-budget-costs-post-plain';
import { ApiTaskBudgetCostGetTaskBudgetCostsPost$Plain$Params } from '../fn/project-tasks/api-task-budget-cost-get-task-budget-costs-post-plain';
import { apiTaskBudgetCostUpdateTaskBudgetCostPost } from '../fn/project-tasks/api-task-budget-cost-update-task-budget-cost-post';
import { ApiTaskBudgetCostUpdateTaskBudgetCostPost$Params } from '../fn/project-tasks/api-task-budget-cost-update-task-budget-cost-post';
import { apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain } from '../fn/project-tasks/api-task-budget-cost-update-task-budget-cost-post-plain';
import { ApiTaskBudgetCostUpdateTaskBudgetCostPost$Plain$Params } from '../fn/project-tasks/api-task-budget-cost-update-task-budget-cost-post-plain';
import { apiTaskProgressCreateTaskProgressPost } from '../fn/project-tasks/api-task-progress-create-task-progress-post';
import { ApiTaskProgressCreateTaskProgressPost$Params } from '../fn/project-tasks/api-task-progress-create-task-progress-post';
import { apiTaskProgressCreateTaskProgressPost$Plain } from '../fn/project-tasks/api-task-progress-create-task-progress-post-plain';
import { ApiTaskProgressCreateTaskProgressPost$Plain$Params } from '../fn/project-tasks/api-task-progress-create-task-progress-post-plain';
import { apiTaskProgressDeleteTaskProgressDelete } from '../fn/project-tasks/api-task-progress-delete-task-progress-delete';
import { ApiTaskProgressDeleteTaskProgressDelete$Params } from '../fn/project-tasks/api-task-progress-delete-task-progress-delete';
import { apiTaskProgressDeleteTaskProgressDelete$Plain } from '../fn/project-tasks/api-task-progress-delete-task-progress-delete-plain';
import { ApiTaskProgressDeleteTaskProgressDelete$Plain$Params } from '../fn/project-tasks/api-task-progress-delete-task-progress-delete-plain';
import { apiTaskProgressGetTaskProgressesPost } from '../fn/project-tasks/api-task-progress-get-task-progresses-post';
import { ApiTaskProgressGetTaskProgressesPost$Params } from '../fn/project-tasks/api-task-progress-get-task-progresses-post';
import { apiTaskProgressGetTaskProgressesPost$Plain } from '../fn/project-tasks/api-task-progress-get-task-progresses-post-plain';
import { ApiTaskProgressGetTaskProgressesPost$Plain$Params } from '../fn/project-tasks/api-task-progress-get-task-progresses-post-plain';
import { apiTaskProgressUpdateTaskProgressPost } from '../fn/project-tasks/api-task-progress-update-task-progress-post';
import { ApiTaskProgressUpdateTaskProgressPost$Params } from '../fn/project-tasks/api-task-progress-update-task-progress-post';
import { apiTaskProgressUpdateTaskProgressPost$Plain } from '../fn/project-tasks/api-task-progress-update-task-progress-post-plain';
import { ApiTaskProgressUpdateTaskProgressPost$Plain$Params } from '../fn/project-tasks/api-task-progress-update-task-progress-post-plain';
import { CreateProjectItemTaskCommandResult } from '../models/create-project-item-task-command-result';
import { CreateProjectTaskBudgetCostCommandResult } from '../models/create-project-task-budget-cost-command-result';
import { CreateProjectTaskCommandResult } from '../models/create-project-task-command-result';
import { CreateProjectTaskDependencyCommandResult } from '../models/create-project-task-dependency-command-result';
import { CreateTaskProgressCommandResult } from '../models/create-task-progress-command-result';
import { DeleteProjectItemTaskCommandResult } from '../models/delete-project-item-task-command-result';
import { DeleteProjectTaskBudgetCostCommandResult } from '../models/delete-project-task-budget-cost-command-result';
import { DeleteProjectTaskCommandResult } from '../models/delete-project-task-command-result';
import { DeleteProjectTaskDependencyCommandResult } from '../models/delete-project-task-dependency-command-result';
import { DeleteTaskProgressCommandResult } from '../models/delete-task-progress-command-result';
import { GetProjectItemTaskQueryResult } from '../models/get-project-item-task-query-result';
import { GetProjectTaskBudgetCostsQueryResult } from '../models/get-project-task-budget-costs-query-result';
import { GetProjectTaskDependenciesQueryResult } from '../models/get-project-task-dependencies-query-result';
import { GetProjectTaskQueryResult } from '../models/get-project-task-query-result';
import { GetProjectTasksNamesQueryResult } from '../models/get-project-tasks-names-query-result';
import { GetProjectTasksQueryResult } from '../models/get-project-tasks-query-result';
import { GetTaskProgressQueryResult } from '../models/get-task-progress-query-result';
import { UpdateProjectItemTaskCommandResult } from '../models/update-project-item-task-command-result';
import { UpdateProjectTaskBudgetCostCommandResult } from '../models/update-project-task-budget-cost-command-result';
import { UpdateProjectTaskCommandResult } from '../models/update-project-task-command-result';
import { UpdateProjectTaskDependencyCommandResult } from '../models/update-project-task-dependency-command-result';
import { UpdateTaskProgressCommandResult } from '../models/update-task-progress-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectTasksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectItemsTasksGetProjectItemsTasksPost()` */
  static readonly ApiProjectItemsTasksGetProjectItemsTasksPostPath = '/api/ProjectItemsTasks/GetProjectItemsTasks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemsTasksGetProjectItemsTasksPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksGetProjectItemsTasksPost$Plain$Response(params?: ApiProjectItemsTasksGetProjectItemsTasksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemTaskQueryResult>> {
    return apiProjectItemsTasksGetProjectItemsTasksPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemsTasksGetProjectItemsTasksPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksGetProjectItemsTasksPost$Plain(params?: ApiProjectItemsTasksGetProjectItemsTasksPost$Plain$Params, context?: HttpContext): Observable<GetProjectItemTaskQueryResult> {
    return this.apiProjectItemsTasksGetProjectItemsTasksPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemTaskQueryResult>): GetProjectItemTaskQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemsTasksGetProjectItemsTasksPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksGetProjectItemsTasksPost$Response(params?: ApiProjectItemsTasksGetProjectItemsTasksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemTaskQueryResult>> {
    return apiProjectItemsTasksGetProjectItemsTasksPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemsTasksGetProjectItemsTasksPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksGetProjectItemsTasksPost(params?: ApiProjectItemsTasksGetProjectItemsTasksPost$Params, context?: HttpContext): Observable<GetProjectItemTaskQueryResult> {
    return this.apiProjectItemsTasksGetProjectItemsTasksPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemTaskQueryResult>): GetProjectItemTaskQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemsTasksCreateProjectItemTaskPost()` */
  static readonly ApiProjectItemsTasksCreateProjectItemTaskPostPath = '/api/ProjectItemsTasks/CreateProjectItemTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemsTasksCreateProjectItemTaskPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksCreateProjectItemTaskPost$Plain$Response(params?: ApiProjectItemsTasksCreateProjectItemTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemTaskCommandResult>> {
    return apiProjectItemsTasksCreateProjectItemTaskPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemsTasksCreateProjectItemTaskPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksCreateProjectItemTaskPost$Plain(params?: ApiProjectItemsTasksCreateProjectItemTaskPost$Plain$Params, context?: HttpContext): Observable<CreateProjectItemTaskCommandResult> {
    return this.apiProjectItemsTasksCreateProjectItemTaskPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectItemTaskCommandResult>): CreateProjectItemTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemsTasksCreateProjectItemTaskPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksCreateProjectItemTaskPost$Response(params?: ApiProjectItemsTasksCreateProjectItemTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemTaskCommandResult>> {
    return apiProjectItemsTasksCreateProjectItemTaskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemsTasksCreateProjectItemTaskPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksCreateProjectItemTaskPost(params?: ApiProjectItemsTasksCreateProjectItemTaskPost$Params, context?: HttpContext): Observable<CreateProjectItemTaskCommandResult> {
    return this.apiProjectItemsTasksCreateProjectItemTaskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectItemTaskCommandResult>): CreateProjectItemTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemsTasksUpdateProjectItemTaskPost()` */
  static readonly ApiProjectItemsTasksUpdateProjectItemTaskPostPath = '/api/ProjectItemsTasks/UpdateProjectItemTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemsTasksUpdateProjectItemTaskPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksUpdateProjectItemTaskPost$Plain$Response(params?: ApiProjectItemsTasksUpdateProjectItemTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemTaskCommandResult>> {
    return apiProjectItemsTasksUpdateProjectItemTaskPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemsTasksUpdateProjectItemTaskPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksUpdateProjectItemTaskPost$Plain(params?: ApiProjectItemsTasksUpdateProjectItemTaskPost$Plain$Params, context?: HttpContext): Observable<UpdateProjectItemTaskCommandResult> {
    return this.apiProjectItemsTasksUpdateProjectItemTaskPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectItemTaskCommandResult>): UpdateProjectItemTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemsTasksUpdateProjectItemTaskPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksUpdateProjectItemTaskPost$Response(params?: ApiProjectItemsTasksUpdateProjectItemTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemTaskCommandResult>> {
    return apiProjectItemsTasksUpdateProjectItemTaskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemsTasksUpdateProjectItemTaskPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksUpdateProjectItemTaskPost(params?: ApiProjectItemsTasksUpdateProjectItemTaskPost$Params, context?: HttpContext): Observable<UpdateProjectItemTaskCommandResult> {
    return this.apiProjectItemsTasksUpdateProjectItemTaskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectItemTaskCommandResult>): UpdateProjectItemTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemsTasksDeleteProjectItemTaskDelete()` */
  static readonly ApiProjectItemsTasksDeleteProjectItemTaskDeletePath = '/api/ProjectItemsTasks/DeleteProjectItemTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain$Response(params?: ApiProjectItemsTasksDeleteProjectItemTaskDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemTaskCommandResult>> {
    return apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain(params?: ApiProjectItemsTasksDeleteProjectItemTaskDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectItemTaskCommandResult> {
    return this.apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectItemTaskCommandResult>): DeleteProjectItemTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemsTasksDeleteProjectItemTaskDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksDeleteProjectItemTaskDelete$Response(params?: ApiProjectItemsTasksDeleteProjectItemTaskDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemTaskCommandResult>> {
    return apiProjectItemsTasksDeleteProjectItemTaskDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemsTasksDeleteProjectItemTaskDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemsTasksDeleteProjectItemTaskDelete(params?: ApiProjectItemsTasksDeleteProjectItemTaskDelete$Params, context?: HttpContext): Observable<DeleteProjectItemTaskCommandResult> {
    return this.apiProjectItemsTasksDeleteProjectItemTaskDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectItemTaskCommandResult>): DeleteProjectItemTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskBudgetCostGetTaskBudgetCostsPost()` */
  static readonly ApiTaskBudgetCostGetTaskBudgetCostsPostPath = '/api/TaskBudgetCost/GetTaskBudgetCosts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskBudgetCostGetTaskBudgetCostsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostGetTaskBudgetCostsPost$Plain$Response(params?: ApiTaskBudgetCostGetTaskBudgetCostsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskBudgetCostsQueryResult>> {
    return apiTaskBudgetCostGetTaskBudgetCostsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskBudgetCostGetTaskBudgetCostsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostGetTaskBudgetCostsPost$Plain(params?: ApiTaskBudgetCostGetTaskBudgetCostsPost$Plain$Params, context?: HttpContext): Observable<GetProjectTaskBudgetCostsQueryResult> {
    return this.apiTaskBudgetCostGetTaskBudgetCostsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTaskBudgetCostsQueryResult>): GetProjectTaskBudgetCostsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskBudgetCostGetTaskBudgetCostsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostGetTaskBudgetCostsPost$Response(params?: ApiTaskBudgetCostGetTaskBudgetCostsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskBudgetCostsQueryResult>> {
    return apiTaskBudgetCostGetTaskBudgetCostsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskBudgetCostGetTaskBudgetCostsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostGetTaskBudgetCostsPost(params?: ApiTaskBudgetCostGetTaskBudgetCostsPost$Params, context?: HttpContext): Observable<GetProjectTaskBudgetCostsQueryResult> {
    return this.apiTaskBudgetCostGetTaskBudgetCostsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTaskBudgetCostsQueryResult>): GetProjectTaskBudgetCostsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiTaskBudgetCostCreateTaskBudgetCostPost()` */
  static readonly ApiTaskBudgetCostCreateTaskBudgetCostPostPath = '/api/TaskBudgetCost/CreateTaskBudgetCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskBudgetCostCreateTaskBudgetCostPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostCreateTaskBudgetCostPost$Plain$Response(params?: ApiTaskBudgetCostCreateTaskBudgetCostPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskBudgetCostCommandResult>> {
    return apiTaskBudgetCostCreateTaskBudgetCostPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskBudgetCostCreateTaskBudgetCostPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostCreateTaskBudgetCostPost$Plain(params?: ApiTaskBudgetCostCreateTaskBudgetCostPost$Plain$Params, context?: HttpContext): Observable<CreateProjectTaskBudgetCostCommandResult> {
    return this.apiTaskBudgetCostCreateTaskBudgetCostPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectTaskBudgetCostCommandResult>): CreateProjectTaskBudgetCostCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskBudgetCostCreateTaskBudgetCostPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostCreateTaskBudgetCostPost$Response(params?: ApiTaskBudgetCostCreateTaskBudgetCostPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskBudgetCostCommandResult>> {
    return apiTaskBudgetCostCreateTaskBudgetCostPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskBudgetCostCreateTaskBudgetCostPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostCreateTaskBudgetCostPost(params?: ApiTaskBudgetCostCreateTaskBudgetCostPost$Params, context?: HttpContext): Observable<CreateProjectTaskBudgetCostCommandResult> {
    return this.apiTaskBudgetCostCreateTaskBudgetCostPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectTaskBudgetCostCommandResult>): CreateProjectTaskBudgetCostCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskBudgetCostUpdateTaskBudgetCostPost()` */
  static readonly ApiTaskBudgetCostUpdateTaskBudgetCostPostPath = '/api/TaskBudgetCost/UpdateTaskBudgetCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain$Response(params?: ApiTaskBudgetCostUpdateTaskBudgetCostPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskBudgetCostCommandResult>> {
    return apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain(params?: ApiTaskBudgetCostUpdateTaskBudgetCostPost$Plain$Params, context?: HttpContext): Observable<UpdateProjectTaskBudgetCostCommandResult> {
    return this.apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectTaskBudgetCostCommandResult>): UpdateProjectTaskBudgetCostCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskBudgetCostUpdateTaskBudgetCostPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostUpdateTaskBudgetCostPost$Response(params?: ApiTaskBudgetCostUpdateTaskBudgetCostPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskBudgetCostCommandResult>> {
    return apiTaskBudgetCostUpdateTaskBudgetCostPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskBudgetCostUpdateTaskBudgetCostPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostUpdateTaskBudgetCostPost(params?: ApiTaskBudgetCostUpdateTaskBudgetCostPost$Params, context?: HttpContext): Observable<UpdateProjectTaskBudgetCostCommandResult> {
    return this.apiTaskBudgetCostUpdateTaskBudgetCostPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectTaskBudgetCostCommandResult>): UpdateProjectTaskBudgetCostCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskBudgetCostDeleteTaskBudgetCostDelete()` */
  static readonly ApiTaskBudgetCostDeleteTaskBudgetCostDeletePath = '/api/TaskBudgetCost/DeleteTaskBudgetCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain$Response(params?: ApiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskBudgetCostCommandResult>> {
    return apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain(params?: ApiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectTaskBudgetCostCommandResult> {
    return this.apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectTaskBudgetCostCommandResult>): DeleteProjectTaskBudgetCostCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskBudgetCostDeleteTaskBudgetCostDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostDeleteTaskBudgetCostDelete$Response(params?: ApiTaskBudgetCostDeleteTaskBudgetCostDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskBudgetCostCommandResult>> {
    return apiTaskBudgetCostDeleteTaskBudgetCostDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskBudgetCostDeleteTaskBudgetCostDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskBudgetCostDeleteTaskBudgetCostDelete(params?: ApiTaskBudgetCostDeleteTaskBudgetCostDelete$Params, context?: HttpContext): Observable<DeleteProjectTaskBudgetCostCommandResult> {
    return this.apiTaskBudgetCostDeleteTaskBudgetCostDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectTaskBudgetCostCommandResult>): DeleteProjectTaskBudgetCostCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskGetProjectTaskPost()` */
  static readonly ApiProjectTaskGetProjectTaskPostPath = '/api/ProjectTask/GetProjectTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskGetProjectTaskPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTaskPost$Plain$Response(params?: ApiProjectTaskGetProjectTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskQueryResult>> {
    return apiProjectTaskGetProjectTaskPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskGetProjectTaskPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTaskPost$Plain(params?: ApiProjectTaskGetProjectTaskPost$Plain$Params, context?: HttpContext): Observable<GetProjectTaskQueryResult> {
    return this.apiProjectTaskGetProjectTaskPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTaskQueryResult>): GetProjectTaskQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskGetProjectTaskPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTaskPost$Response(params?: ApiProjectTaskGetProjectTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskQueryResult>> {
    return apiProjectTaskGetProjectTaskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskGetProjectTaskPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTaskPost(params?: ApiProjectTaskGetProjectTaskPost$Params, context?: HttpContext): Observable<GetProjectTaskQueryResult> {
    return this.apiProjectTaskGetProjectTaskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTaskQueryResult>): GetProjectTaskQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskGetProjectTasksNamesPost()` */
  static readonly ApiProjectTaskGetProjectTasksNamesPostPath = '/api/ProjectTask/GetProjectTasksNames';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskGetProjectTasksNamesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTasksNamesPost$Plain$Response(params?: ApiProjectTaskGetProjectTasksNamesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTasksNamesQueryResult>> {
    return apiProjectTaskGetProjectTasksNamesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskGetProjectTasksNamesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTasksNamesPost$Plain(params?: ApiProjectTaskGetProjectTasksNamesPost$Plain$Params, context?: HttpContext): Observable<GetProjectTasksNamesQueryResult> {
    return this.apiProjectTaskGetProjectTasksNamesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTasksNamesQueryResult>): GetProjectTasksNamesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskGetProjectTasksNamesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTasksNamesPost$Response(params?: ApiProjectTaskGetProjectTasksNamesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTasksNamesQueryResult>> {
    return apiProjectTaskGetProjectTasksNamesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskGetProjectTasksNamesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTasksNamesPost(params?: ApiProjectTaskGetProjectTasksNamesPost$Params, context?: HttpContext): Observable<GetProjectTasksNamesQueryResult> {
    return this.apiProjectTaskGetProjectTasksNamesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTasksNamesQueryResult>): GetProjectTasksNamesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskGetProjectTasksPost()` */
  static readonly ApiProjectTaskGetProjectTasksPostPath = '/api/ProjectTask/GetProjectTasks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskGetProjectTasksPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTasksPost$Plain$Response(params?: ApiProjectTaskGetProjectTasksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTasksQueryResult>> {
    return apiProjectTaskGetProjectTasksPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskGetProjectTasksPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTasksPost$Plain(params?: ApiProjectTaskGetProjectTasksPost$Plain$Params, context?: HttpContext): Observable<GetProjectTasksQueryResult> {
    return this.apiProjectTaskGetProjectTasksPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTasksQueryResult>): GetProjectTasksQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskGetProjectTasksPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTasksPost$Response(params?: ApiProjectTaskGetProjectTasksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTasksQueryResult>> {
    return apiProjectTaskGetProjectTasksPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskGetProjectTasksPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskGetProjectTasksPost(params?: ApiProjectTaskGetProjectTasksPost$Params, context?: HttpContext): Observable<GetProjectTasksQueryResult> {
    return this.apiProjectTaskGetProjectTasksPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTasksQueryResult>): GetProjectTasksQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskCreateProjectTaskPost()` */
  static readonly ApiProjectTaskCreateProjectTaskPostPath = '/api/ProjectTask/CreateProjectTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskCreateProjectTaskPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskCreateProjectTaskPost$Plain$Response(params?: ApiProjectTaskCreateProjectTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskCommandResult>> {
    return apiProjectTaskCreateProjectTaskPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskCreateProjectTaskPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskCreateProjectTaskPost$Plain(params?: ApiProjectTaskCreateProjectTaskPost$Plain$Params, context?: HttpContext): Observable<CreateProjectTaskCommandResult> {
    return this.apiProjectTaskCreateProjectTaskPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectTaskCommandResult>): CreateProjectTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskCreateProjectTaskPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskCreateProjectTaskPost$Response(params?: ApiProjectTaskCreateProjectTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskCommandResult>> {
    return apiProjectTaskCreateProjectTaskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskCreateProjectTaskPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskCreateProjectTaskPost(params?: ApiProjectTaskCreateProjectTaskPost$Params, context?: HttpContext): Observable<CreateProjectTaskCommandResult> {
    return this.apiProjectTaskCreateProjectTaskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectTaskCommandResult>): CreateProjectTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskUpdateProjectTaskPost()` */
  static readonly ApiProjectTaskUpdateProjectTaskPostPath = '/api/ProjectTask/UpdateProjectTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskUpdateProjectTaskPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskUpdateProjectTaskPost$Plain$Response(params?: ApiProjectTaskUpdateProjectTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskCommandResult>> {
    return apiProjectTaskUpdateProjectTaskPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskUpdateProjectTaskPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskUpdateProjectTaskPost$Plain(params?: ApiProjectTaskUpdateProjectTaskPost$Plain$Params, context?: HttpContext): Observable<UpdateProjectTaskCommandResult> {
    return this.apiProjectTaskUpdateProjectTaskPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectTaskCommandResult>): UpdateProjectTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskUpdateProjectTaskPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskUpdateProjectTaskPost$Response(params?: ApiProjectTaskUpdateProjectTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskCommandResult>> {
    return apiProjectTaskUpdateProjectTaskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskUpdateProjectTaskPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskUpdateProjectTaskPost(params?: ApiProjectTaskUpdateProjectTaskPost$Params, context?: HttpContext): Observable<UpdateProjectTaskCommandResult> {
    return this.apiProjectTaskUpdateProjectTaskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectTaskCommandResult>): UpdateProjectTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskDeleteProjectTaskDelete()` */
  static readonly ApiProjectTaskDeleteProjectTaskDeletePath = '/api/ProjectTask/DeleteProjectTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDeleteProjectTaskDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDeleteProjectTaskDelete$Plain$Response(params?: ApiProjectTaskDeleteProjectTaskDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskCommandResult>> {
    return apiProjectTaskDeleteProjectTaskDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDeleteProjectTaskDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDeleteProjectTaskDelete$Plain(params?: ApiProjectTaskDeleteProjectTaskDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectTaskCommandResult> {
    return this.apiProjectTaskDeleteProjectTaskDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectTaskCommandResult>): DeleteProjectTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDeleteProjectTaskDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDeleteProjectTaskDelete$Response(params?: ApiProjectTaskDeleteProjectTaskDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskCommandResult>> {
    return apiProjectTaskDeleteProjectTaskDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDeleteProjectTaskDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDeleteProjectTaskDelete(params?: ApiProjectTaskDeleteProjectTaskDelete$Params, context?: HttpContext): Observable<DeleteProjectTaskCommandResult> {
    return this.apiProjectTaskDeleteProjectTaskDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectTaskCommandResult>): DeleteProjectTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskProgressGetTaskProgressesPost()` */
  static readonly ApiTaskProgressGetTaskProgressesPostPath = '/api/TaskProgress/GetTaskProgresses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskProgressGetTaskProgressesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressGetTaskProgressesPost$Plain$Response(params?: ApiTaskProgressGetTaskProgressesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTaskProgressQueryResult>> {
    return apiTaskProgressGetTaskProgressesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskProgressGetTaskProgressesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressGetTaskProgressesPost$Plain(params?: ApiTaskProgressGetTaskProgressesPost$Plain$Params, context?: HttpContext): Observable<GetTaskProgressQueryResult> {
    return this.apiTaskProgressGetTaskProgressesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetTaskProgressQueryResult>): GetTaskProgressQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskProgressGetTaskProgressesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressGetTaskProgressesPost$Response(params?: ApiTaskProgressGetTaskProgressesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTaskProgressQueryResult>> {
    return apiTaskProgressGetTaskProgressesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskProgressGetTaskProgressesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressGetTaskProgressesPost(params?: ApiTaskProgressGetTaskProgressesPost$Params, context?: HttpContext): Observable<GetTaskProgressQueryResult> {
    return this.apiTaskProgressGetTaskProgressesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetTaskProgressQueryResult>): GetTaskProgressQueryResult => r.body)
    );
  }

  /** Path part for operation `apiTaskProgressCreateTaskProgressPost()` */
  static readonly ApiTaskProgressCreateTaskProgressPostPath = '/api/TaskProgress/CreateTaskProgress';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskProgressCreateTaskProgressPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressCreateTaskProgressPost$Plain$Response(params?: ApiTaskProgressCreateTaskProgressPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateTaskProgressCommandResult>> {
    return apiTaskProgressCreateTaskProgressPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskProgressCreateTaskProgressPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressCreateTaskProgressPost$Plain(params?: ApiTaskProgressCreateTaskProgressPost$Plain$Params, context?: HttpContext): Observable<CreateTaskProgressCommandResult> {
    return this.apiTaskProgressCreateTaskProgressPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateTaskProgressCommandResult>): CreateTaskProgressCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskProgressCreateTaskProgressPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressCreateTaskProgressPost$Response(params?: ApiTaskProgressCreateTaskProgressPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateTaskProgressCommandResult>> {
    return apiTaskProgressCreateTaskProgressPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskProgressCreateTaskProgressPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressCreateTaskProgressPost(params?: ApiTaskProgressCreateTaskProgressPost$Params, context?: HttpContext): Observable<CreateTaskProgressCommandResult> {
    return this.apiTaskProgressCreateTaskProgressPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateTaskProgressCommandResult>): CreateTaskProgressCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskProgressUpdateTaskProgressPost()` */
  static readonly ApiTaskProgressUpdateTaskProgressPostPath = '/api/TaskProgress/UpdateTaskProgress';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskProgressUpdateTaskProgressPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressUpdateTaskProgressPost$Plain$Response(params?: ApiTaskProgressUpdateTaskProgressPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateTaskProgressCommandResult>> {
    return apiTaskProgressUpdateTaskProgressPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskProgressUpdateTaskProgressPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressUpdateTaskProgressPost$Plain(params?: ApiTaskProgressUpdateTaskProgressPost$Plain$Params, context?: HttpContext): Observable<UpdateTaskProgressCommandResult> {
    return this.apiTaskProgressUpdateTaskProgressPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateTaskProgressCommandResult>): UpdateTaskProgressCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskProgressUpdateTaskProgressPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressUpdateTaskProgressPost$Response(params?: ApiTaskProgressUpdateTaskProgressPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateTaskProgressCommandResult>> {
    return apiTaskProgressUpdateTaskProgressPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskProgressUpdateTaskProgressPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressUpdateTaskProgressPost(params?: ApiTaskProgressUpdateTaskProgressPost$Params, context?: HttpContext): Observable<UpdateTaskProgressCommandResult> {
    return this.apiTaskProgressUpdateTaskProgressPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateTaskProgressCommandResult>): UpdateTaskProgressCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskProgressDeleteTaskProgressDelete()` */
  static readonly ApiTaskProgressDeleteTaskProgressDeletePath = '/api/TaskProgress/DeleteTaskProgress';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskProgressDeleteTaskProgressDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressDeleteTaskProgressDelete$Plain$Response(params?: ApiTaskProgressDeleteTaskProgressDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteTaskProgressCommandResult>> {
    return apiTaskProgressDeleteTaskProgressDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskProgressDeleteTaskProgressDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressDeleteTaskProgressDelete$Plain(params?: ApiTaskProgressDeleteTaskProgressDelete$Plain$Params, context?: HttpContext): Observable<DeleteTaskProgressCommandResult> {
    return this.apiTaskProgressDeleteTaskProgressDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteTaskProgressCommandResult>): DeleteTaskProgressCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskProgressDeleteTaskProgressDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressDeleteTaskProgressDelete$Response(params?: ApiTaskProgressDeleteTaskProgressDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteTaskProgressCommandResult>> {
    return apiTaskProgressDeleteTaskProgressDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskProgressDeleteTaskProgressDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskProgressDeleteTaskProgressDelete(params?: ApiTaskProgressDeleteTaskProgressDelete$Params, context?: HttpContext): Observable<DeleteTaskProgressCommandResult> {
    return this.apiTaskProgressDeleteTaskProgressDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteTaskProgressCommandResult>): DeleteTaskProgressCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskDependencyGetProjectTaskDependenciesPost()` */
  static readonly ApiProjectTaskDependencyGetProjectTaskDependenciesPostPath = '/api/ProjectTaskDependency/GetProjectTaskDependencies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain$Response(params?: ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskDependenciesQueryResult>> {
    return apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain(params?: ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain$Params, context?: HttpContext): Observable<GetProjectTaskDependenciesQueryResult> {
    return this.apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTaskDependenciesQueryResult>): GetProjectTaskDependenciesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDependencyGetProjectTaskDependenciesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyGetProjectTaskDependenciesPost$Response(params?: ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskDependenciesQueryResult>> {
    return apiProjectTaskDependencyGetProjectTaskDependenciesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDependencyGetProjectTaskDependenciesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyGetProjectTaskDependenciesPost(params?: ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Params, context?: HttpContext): Observable<GetProjectTaskDependenciesQueryResult> {
    return this.apiProjectTaskDependencyGetProjectTaskDependenciesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTaskDependenciesQueryResult>): GetProjectTaskDependenciesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskDependencyCreateProjectTaskDependencyPost()` */
  static readonly ApiProjectTaskDependencyCreateProjectTaskDependencyPostPath = '/api/ProjectTaskDependency/CreateProjectTaskDependency';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain$Response(params?: ApiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskDependencyCommandResult>> {
    return apiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain(params?: ApiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain$Params, context?: HttpContext): Observable<CreateProjectTaskDependencyCommandResult> {
    return this.apiProjectTaskDependencyCreateProjectTaskDependencyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectTaskDependencyCommandResult>): CreateProjectTaskDependencyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDependencyCreateProjectTaskDependencyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyCreateProjectTaskDependencyPost$Response(params?: ApiProjectTaskDependencyCreateProjectTaskDependencyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskDependencyCommandResult>> {
    return apiProjectTaskDependencyCreateProjectTaskDependencyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDependencyCreateProjectTaskDependencyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyCreateProjectTaskDependencyPost(params?: ApiProjectTaskDependencyCreateProjectTaskDependencyPost$Params, context?: HttpContext): Observable<CreateProjectTaskDependencyCommandResult> {
    return this.apiProjectTaskDependencyCreateProjectTaskDependencyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectTaskDependencyCommandResult>): CreateProjectTaskDependencyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskDependencyUpdateProjectTaskDependencyPost()` */
  static readonly ApiProjectTaskDependencyUpdateProjectTaskDependencyPostPath = '/api/ProjectTaskDependency/UpdateProjectTaskDependency';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain$Response(params?: ApiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskDependencyCommandResult>> {
    return apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain(params?: ApiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain$Params, context?: HttpContext): Observable<UpdateProjectTaskDependencyCommandResult> {
    return this.apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectTaskDependencyCommandResult>): UpdateProjectTaskDependencyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDependencyUpdateProjectTaskDependencyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Response(params?: ApiProjectTaskDependencyUpdateProjectTaskDependencyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskDependencyCommandResult>> {
    return apiProjectTaskDependencyUpdateProjectTaskDependencyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyUpdateProjectTaskDependencyPost(params?: ApiProjectTaskDependencyUpdateProjectTaskDependencyPost$Params, context?: HttpContext): Observable<UpdateProjectTaskDependencyCommandResult> {
    return this.apiProjectTaskDependencyUpdateProjectTaskDependencyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectTaskDependencyCommandResult>): UpdateProjectTaskDependencyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTaskDependencyDeleteProjectTaskDependencyDelete()` */
  static readonly ApiProjectTaskDependencyDeleteProjectTaskDependencyDeletePath = '/api/ProjectTaskDependency/DeleteProjectTaskDependency';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain$Response(params?: ApiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskDependencyCommandResult>> {
    return apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain(params?: ApiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectTaskDependencyCommandResult> {
    return this.apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectTaskDependencyCommandResult>): DeleteProjectTaskDependencyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTaskDependencyDeleteProjectTaskDependencyDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Response(params?: ApiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskDependencyCommandResult>> {
    return apiProjectTaskDependencyDeleteProjectTaskDependencyDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTaskDependencyDeleteProjectTaskDependencyDelete(params?: ApiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Params, context?: HttpContext): Observable<DeleteProjectTaskDependencyCommandResult> {
    return this.apiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectTaskDependencyCommandResult>): DeleteProjectTaskDependencyCommandResult => r.body)
    );
  }

}
